import React from "react";
import styles from "../styles/Callus.module.css";
import call from "../images/callus pic/call.png";
import wa from "../images/callus pic/waths app.png";
import tl from "../images/callus pic/telegram.png";
import ins from "../images/callus pic/instagram.png";
const Callus = () => {
  const phoneNumber = "09907727813"; // Replace with the desired phone number
  return (
    <></>
    // <div className={styles.container}>
    //   <p>برای مشاوره بیشترباما درارتباط باشید</p>
    //   <div className={styles.con2}>
    //     <a href={`tel:${phoneNumber}`}>
    //       {" "}
    //       <img src={call} />{" "}
    //     </a>
    //     <img src={wa} />
    //     <img src={tl} />
    //     <img src={ins} />
    //   </div>
    // </div>
  );
};

export default Callus;
